import { Ticket } from "@services/tickets/types";

export type Alarms = {
  pageAlerts?: AlarmAlert[];
  warningPageAlerts?: AlarmAlert[];
  tickets?: Ticket[];
};

export enum AlarmAlertMessagingTypes {
  "Symphony Popup" = "Symphony Popup",
  "System Popup" = "System Popup",
  "Warning Page Alert" = "Warning Page Alert",
}

export interface AlarmAlert {
  id: number;
  messagingTypes: AlarmAlertMessagingTypes[];
  content: string;
  accountIds: string[];
  startDate: number | null;
  endDate: number | null;
  closable: boolean;
}

export type MessageStatus = "onGoing" | "scheduled";

export const messagesStatus: MessageStatus[] = ["onGoing", "scheduled"];

export interface AlarmFilters {
  accountId?: string[];
}

export interface MetaData {
  id?: number;
  graphName: string;
  graphType: string;
  deviceManufacturer?: string;
  deviceModel?: string;
  unit?: string;
  properties?: string[];
  minValue: number;
  maxValue?: number;
}

export type DeviceGraphMetaData = MetaData[] & { deviceId: string };

export enum GraphType {
  Bit_Rate_Audio = "Bit_Rate_Audio",
  Bit_Rate_Content = "Bit_Rate_Content",
  Bit_Rate_Video = "Bit_Rate_Video",
  Call_Rate = "Call_Rate",
  Cpu = "Cpu",
  Frame_Rate = "Frame_Rate",
  Frame_Rate_Content = "Frame_Rate_Content",
  Jitter_Audio = "Jitter_Audio",
  Jitter_Content = "Jitter_Content",
  Jitter_Video = "Jitter_Video",
  Memory_In_Use = "Memory_In_Use",
  Network = "Network",
  Packet_Loss = "Packet_Loss",
  Packet_Loss_Audio = "Packet_Loss_Audio",
  Packet_Loss_Content = "Packet_Loss_Content",
  Packet_Loss_Percentage_Content = "Packet_Loss_Percentage_Content",
  Packet_Loss_Video = "Packet_Loss_Video",
  Ping_Latency = "Ping_Latency",
  Port_Usage_Video = "Port_Usage_Video",
}

export enum GraphColor {
  pink = "pink",
  purple = "purple",
  blue = "blue",
  teal = "teal",
  green = "green",
  mustard = "mustard",
}

export interface MonitoringGraphData {
  minorThreshold?: number;
  deviceId?: string;
  name?: string;
  majorThreshold?: number;
  data?: [number, number | null][];
  criticalThreshold?: number;
}

export type ThresholdKeys = Extract<
  keyof MonitoringGraphData,
  "minorThreshold" | "majorThreshold" | "criticalThreshold"
>;

export const thresholdFields: ThresholdKeys[] = [
  "minorThreshold",
  "majorThreshold",
  "criticalThreshold",
];

export interface MonitoringPause {
  since?: number;
  until?: number;
  comment?: string;
}
